module.exports = __webpack_public_path__ + "media/images/file-icon-b09069274707fe1084a046c7b23c6f6f.svg";